export const PreventionInvalidityCode = {
    INVALID_PART: 'INVALID_PART',
    INVALID_CUSTOMER: 'INVALID_CUSTOMER',
    INVALID_TERRITORY: 'INVALID_TERRITORY',
    INVALID_ACCOUNT_MANAGER: 'INVALID_ACCOUNT_MANAGER',
    INVALID_VENDOR: 'INVALID_VENDOR',
    INVALID_WAREHOUSE: 'INVALID_WAREHOUSE',
    INVALID_PARTNER: 'INVALID_PARTNER',
    INVALID_TAG: 'INVALID_TAG',
    INVALID_FORM: 'INVALID_FORM',
    INVALID_RELATION: 'INVALID_RELATION',
    INVALID_RELATION_ASSIGNMENT: 'INVALID_RELATION_ASSIGNMENT',
    INVALID_BOOLEAN: 'INVALID_BOOLEAN',
    INVALID_DELIVERY_MODE: 'INVALID_DELIVERY_MODE',
    INVALID_CODE: 'INVALID_CODE',
    MISSING_REQUIRED_FIELDS: 'MISSING_REQUIRED_FIELDS',
    INVALID_PREDEFINED_OPTION: 'INVALID_PREDEFINED_OPTION',
    MULTISELECT_NOT_SUPPORTED: 'MULTISELECT_NOT_SUPPORTED',
    INVALID_AMOUNT: 'INVALID_AMOUNT',
    SERIAL_COUNT_MISMATCH: 'SERIAL_COUNT_MISMATCH',
    SERIALS_NOT_ALLOWED: 'SERIALS_NOT_ALLOWED',
};
